export const ErrorActionTypes = {
  RECEIVE_ERRORS: 'RECEIVE_ERRORS',
  CLEAR_ERRORS: 'CLEAR_ERRORS'
};
